// extracted by mini-css-extract-plugin
export var container = "_5g-0";
export var icon = "_5g-1";
export var text = "_5g-2";